import {
  GET_INSTITUTION_TYPE_LIST_START,
  GET_INSTITUTION_TYPE_LIST,
  GET_INSTITUTION_TYPE_LIST_ERROR,
} from '../actions/types';

const initialState = {
  institutionTypeList: [],
  institutionType: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const findAllInstitutionType = (state, action) => {
  return {
    ...state,
    loading: false,
    institutionTypeList: action.payload,
    error: undefined,
  };
};

const findAllInstitutionTypeStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllInstitutionTypeError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_INSTITUTION_TYPE_LIST:
      return findAllInstitutionType(state, action);
    case GET_INSTITUTION_TYPE_LIST_START:
      return findAllInstitutionTypeStart(state, action);
    case GET_INSTITUTION_TYPE_LIST_ERROR:
      return findAllInstitutionTypeError(state, action);

    default:
      return state;
  }
}
